import { render, staticRenderFns } from "./chateau-talbot.vue?vue&type=template&id=c7c00dfe&scoped=true"
import script from "./chateau-talbot.vue?vue&type=script&lang=js"
export * from "./chateau-talbot.vue?vue&type=script&lang=js"
import style0 from "./chateau-talbot.vue?vue&type=style&index=0&id=c7c00dfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c00dfe",
  null
  
)

export default component.exports